module.exports = __webpack_public_path__ + "static/img/2.64f7a14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/2.jpg
// module id = SOwD
// module chunks = 2